import { Result } from "antd";
import React from "react";

const Feedback = (props) => {
  return (
    <Result
      title={props.title}
      subTitle={props.subTitle}
      status={props.status}
      icon={props.icon ? props.icon : null}
      data-testid='feedback'
    ></Result>
  );
};

export default Feedback;
